/**
 * @author      yewon@zumper.com (Yewon Lee)
 * @copyright   Copyright (c) 2018, Zumper
 * @description limitReducer
 */

import { LISTABLES_API_LIMIT, LISTABLES_API_LIMIT_MAX } from '@zcode/nr/es/shared/constants/list'
import { combineActions, handleActions } from 'redux-actions'

import {
  GET_LISTABLES_SUCCESS,
  HIDE,
  RESET_LISTABLES,
  RESET_SAVED_SEARCHES_VIEW,
  SET_LISTABLES_LIMIT,
} from '../constants/index'

const limitReducer = handleActions(
  {
    [SET_LISTABLES_LIMIT]: (state, action) => {
      const limit = action.payload
      let value = limit
      if (limit < LISTABLES_API_LIMIT) {
        value = LISTABLES_API_LIMIT
      } else if (limit > LISTABLES_API_LIMIT_MAX) {
        value = LISTABLES_API_LIMIT_MAX
      }
      return value
    },
    [GET_LISTABLES_SUCCESS]: (state, action) => {
      const { payload } = action
      if (payload) {
        const { offset } = payload

        // capture the offset
        if (!offset) {
          // for fresh results, reset the limit and loadMoreCount
          return LISTABLES_API_LIMIT
        }
      }
      return state
    },
    [combineActions(HIDE, RESET_LISTABLES, RESET_SAVED_SEARCHES_VIEW)]: () => LISTABLES_API_LIMIT,
  },
  LISTABLES_API_LIMIT
)

export default limitReducer
